import { AxiosResponse } from 'axios';
import { MutationOptions, useMutation } from '@tanstack/react-query';
import { validateParameterExpression } from 'Services';
import { RQ_VALIDATE_PARAMETER_EXPRESSION } from 'Utils';

type Options = {
    mutationOptions: Omit<MutationOptions<AxiosResponse<ParameterExpression>, any, any, any>, 'mutationKey'>;
};

function useValidateParameterExpression({ mutationOptions }: Options) {
    return useMutation([RQ_VALIDATE_PARAMETER_EXPRESSION], validateParameterExpression, {
        ...mutationOptions,
        onSuccess: (data, variables, context) => {
            mutationOptions.onSuccess?.(data, variables, context);
        },
        onError: async (error, variables, context) => mutationOptions.onError?.(error, variables, context)
    });
}

export default useValidateParameterExpression;
